/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : Footer.jsx
 * description   : {{insert here}}
 * creation date : 01/02/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    I18n,
} from '@aws-amplify/core';

import {
    Flex,
    Text,
    View,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
} from '@/components/core';

import {
    locale_msg,
} from '@/utils/locale/enums';

import {
    LinkText,
} from '@/components/snippets/RouterLink';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function Footer() {
    // Component context
    const { ctx } = useComponentContext();

    // Current date
    const now = new Date();

    // Compute copyright period
    var date_period = (('' + now.getFullYear()) === process.env.REACT_APP__FOUNDATION_DATE__YEAR) ?
        now.getFullYear() :
        process.env.REACT_APP__FOUNDATION_DATE__YEAR + '-' + now.getFullYear();

    return (
        <Fragment>
            <View
                className='authenticator-footer'
            >
                <Flex
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    alignContent='center'
                    wrap='wrap'
                    gap={ctx.theme.tokens.space.zero}
                >
                    <Text
                        variation='tertiary'
                    >
                        &copy;&nbsp;{date_period}&nbsp;
                    </Text>

                    <LinkText
                        to={window.location.origin}
                        variation='tertiary'
                    >
                        {process.env.REACT_APP__PROJECT__NAME.toLocaleLowerCase()}
                    </LinkText>

                    <Text
                        variation='tertiary'
                    >
                        &nbsp;&reg;,&nbsp;
                    </Text>

                    <Text
                        variation='tertiary'
                    >
                        {I18n.get(locale_msg.GENERAL__COPYRIGHT) + '.'}
                    </Text>
                </Flex>
            </View>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default Footer;



// End of file
